import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '剧情解析', path: '/category/plot-analysis' },
  { name: '角色介绍', path: '/category/characters' },
  { name: '声优阵容', path: '/category/voice-actors' },
  { name: 'OVA特辑', path: '/category/ova' },
  { name: '名场面', path: '/category/iconic-scenes' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'}`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-xl md:text-2xl font-heading text-primary-500 font-bold whitespace-nowrap">
              亲吻姐姐
            </span>
            <span className={`hidden md:inline text-xs font-body transition-colors whitespace-nowrap ${scrolled ? 'text-foreground-600' : 'text-white/80'}`}>
              官方解析站
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2 rounded-lg text-sm font-body transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'bg-primary-500/10 text-primary-600 font-medium'
                    : scrolled
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                    : 'text-white/85 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${scrolled ? 'text-foreground-700' : 'text-white'}`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-body transition-colors ${
                  location.pathname === link.path
                    ? 'bg-primary-500/10 text-primary-600 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}